import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34137ad4")

_pushScopeId("data-v-34137ad4")
const _hoisted_1 = { class: "product-title" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-6 order-md-1" }
const _hoisted_5 = { class: "row selling-settings-item" }
const _hoisted_6 = { class: "col-10 col-md-9" }
const _hoisted_7 = { class: "selling-settings-item-name pl-15" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "col-12 col-md-6 order-md-3"
}
const _hoisted_10 = { class: "row selling-settings-item" }
const _hoisted_11 = { class: "col-12 printing-type-title" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "col-12 col-md-6 order-md-2" }
const _hoisted_14 = { class: "row selling-settings-item" }
const _hoisted_15 = { class: "col-10 col-md-9" }
const _hoisted_16 = { class: "selling-settings-item-name pl-15" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_18 = { class: "col-12 col-md-6 order-md-4" }
const _hoisted_19 = { class: "row selling-settings-item" }
const _hoisted_20 = { class: "col-10 col-md-9" }
const _hoisted_21 = { class: "selling-settings-item-name pl-15" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_23 = { class: "col-12 col-md-6 order-md-5" }
const _hoisted_24 = { class: "row selling-settings-item" }
const _hoisted_25 = { class: "col-10 col-md-9" }
const _hoisted_26 = { class: "selling-settings-item-name pl-15" }
const _hoisted_27 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_28 = { class: "col-12 col-md-6 order-md-6" }
const _hoisted_29 = { class: "row selling-settings-item" }
const _hoisted_30 = { class: "col-10 col-md-9" }
const _hoisted_31 = { class: "selling-settings-item-name pl-15" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_33 = {
  key: 1,
  class: "row"
}
const _hoisted_34 = {
  key: 0,
  class: "col-6 col-md-4"
}
const _hoisted_35 = {
  key: 0,
  style: {"font-size":"14px"}
}
const _hoisted_36 = {
  key: 1,
  class: "col-6 col-md-4"
}
const _hoisted_37 = {
  key: 2,
  class: "col-6 col-md-4"
}
const _hoisted_38 = {
  key: 3,
  class: "col-6 col-md-4"
}
const _hoisted_39 = {
  key: 4,
  class: "col-6 col-md-4"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", {
    class: ["selling-settings-page col-12", { editMode: _ctx.editMode }]
  }, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('product.selling-settings.title')), 1),
    (_ctx.editMode)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle",
                    checked: _ctx.useCashier,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingCashier && _ctx.ChangeSellingSettingCashier(...args)), ["stop"]))
                  }, null, 8, ["checked"]),
                  _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('product.selling-settings.cashier')), 1)
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.cashier.info')
                }, [
                  _hoisted_8
                ], 8, ["title"])
              ])
            ]),
            (_ctx.useCashier)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('ticket-printing-type.lable')), 1),
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_Multiselect, {
                        label: "name",
                        modelValue: _ctx.printingType,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.printingType = $event)),
                        options: _ctx.printingTypes,
                        canDeselect: true,
                        valueProp: "id",
                        searchable: false,
                        onChange: _ctx.ChangeSellingSettingPrintingType
                      }, null, 8, ["modelValue", "options", "onChange"]),
                      (_ctx.printingType)
                        ? (_openBlock(), _createBlock("span", {
                            key: 0,
                            class: "icon-f icon-delete-cross fs-14 deletePrintingType",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ChangeSellingSettingPrintingType(null)))
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle",
                    checked: _ctx.useLocals,
                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingLocals && _ctx.ChangeSellingSettingLocals(...args)), ["stop"]))
                  }, null, 8, ["checked"]),
                  _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('product.selling-settings.locals')), 1)
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.locals.info')
                }, [
                  _hoisted_17
                ], 8, ["title"])
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle",
                    checked: _ctx.useGroups,
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingGroups && _ctx.ChangeSellingSettingGroups(...args)), ["stop"]))
                  }, null, 8, ["checked"]),
                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('product.selling-settings.groups')), 1)
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.groups.info')
                }, [
                  _hoisted_22
                ], 8, ["title"])
              ])
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle",
                    checked: _ctx.useB2cChannels,
                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingB2cChannels && _ctx.ChangeSellingSettingB2cChannels(...args)), ["stop"]))
                  }, null, 8, ["checked"]),
                  _createVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('product.selling-settings.b2c-channels')), 1)
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.b2cchannels.info')
                }, [
                  _hoisted_27
                ], 8, ["title"])
              ])
            ]),
            _createVNode("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle",
                    checked: _ctx.useIndex,
                    onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingIndex && _ctx.ChangeSellingSettingIndex(...args)), ["stop"]))
                  }, null, 8, ["checked"]),
                  _createVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('product.selling-settings.index')), 1)
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.index.info')
                }, [
                  _hoisted_32
                ], 8, ["title"])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_33, [
          (_ctx.useCashier)
            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.cashier')), 1),
                (_ctx.printingType)
                  ? (_openBlock(), _createBlock("span", _hoisted_35, " - " + _toDisplayString(_ctx.$t('printing-type.' + _ctx.PrintingTypeEnum[_ctx.printingType])), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.useLocals)
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.locals')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.useGroups)
            ? (_openBlock(), _createBlock("div", _hoisted_37, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.groups')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.useB2cChannels)
            ? (_openBlock(), _createBlock("div", _hoisted_38, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.b2c-channels')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.useIndex)
            ? (_openBlock(), _createBlock("div", _hoisted_39, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.index')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 2))
})